import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";

let thicknessLayer1 = [
    {id: 0.4, checked: false, text: "0.4", name: "thickness", disabled: true},
    {id: 0.6, checked: false, text: "0.6", name: "thickness", disabled: true},
    {id: 0.8, checked: false, text: "0.8", name: "thickness", disabled: false},
    {id: 1.0, checked: false, text: "1.0", name: "thickness", disabled: false},
    {id: 1.2, checked: false, text: "1.2", name: "thickness", disabled: false},
    {id: 1.6, checked: true, text: "1.6", name: "thickness", disabled: false},
    {id: 2.0, checked: false, text: "2.0", name: "thickness", disabled: false}
];

let thicknessLayer2 = [
    {id: 0.4, checked: false, text: "0.4", name: "thickness", disabled: false},
    {id: 0.6, checked: false, text: "0.6", name: "thickness", disabled: false},
    {id: 0.8, checked: false, text: "0.8", name: "thickness", disabled: false},
    {id: 1.0, checked: false, text: "1.0", name: "thickness", disabled: false},
    {id: 1.2, checked: false, text: "1.2", name: "thickness", disabled: false},
    {id: 1.6, checked: true, text: "1.6", name: "thickness", disabled: false},
    {id: 2.0, checked: false, text: "2.0", name: "thickness", disabled: false}
];

let thicknessLayer4 = [
    {id: 0.4, checked: false, text: "0.4", name: "thickness", disabled: true},
    {id: 0.6, checked: false, text: "0.6", name: "thickness", disabled: true},
    {id: 0.8, checked: false, text: "0.8", name: "thickness", disabled: false},
    {id: 1.0, checked: false, text: "1.0", name: "thickness", disabled: false},
    {id: 1.2, checked: false, text: "1.2", name: "thickness", disabled: false},
    {id: 1.6, checked: true, text: "1.6", name: "thickness", disabled: false},
    {id: 2.0, checked: false, text: "2.0", name: "thickness", disabled: false}
];

let thicknessLayer6 = [
    {id: 0.4, checked: false, text: "0.4", name: "thickness", disabled: true},
    {id: 0.6, checked: false, text: "0.6", name: "thickness", disabled: true},
    {id: 0.8, checked: false, text: "0.8", name: "thickness", disabled: true},
    {id: 1.0, checked: false, text: "1.0", name: "thickness", disabled: true},
    {id: 1.2, checked: false, text: "1.2", name: "thickness", disabled: false},
    {id: 1.6, checked: true, text: "1.6", name: "thickness", disabled: false},
    {id: 2.0, checked: false, text: "2.0", name: "thickness", disabled: false}
];

class PCBThickness extends Component {

    render() {


        let pcbThicknessLayer2 = thicknessLayer4;
        let pcbThicknessLayer4 = thicknessLayer4;
        let pcbThicknessLayer6 = thicknessLayer6;
        let pcbThickness = thicknessLayer1;

        // console.log("PCB LAYER DUO +++++++", this.props.pcbParam.layer);

        if (this.props.pcbParam.layer === 4) {
            // console.log("PCB LAYER 4 DUO");
            pcbThicknessLayer4 = thicknessLayer4.map((item) => {
                item.checked = item.id === this.props.selectedId;
                return item;
            });
        }
        if (this.props.pcbParam.layer === 2) {
            // console.log("PCB LAYER 4 DUO");
            pcbThicknessLayer2 = thicknessLayer2.map((item) => {
                item.checked = item.id === this.props.selectedId;
                return item;
            });
        }else if (this.props.pcbParam.layer === 6) {
            // console.log("PCB LAYER 6 DUO");
            pcbThicknessLayer6 = thicknessLayer6.map((item) => {
                item.checked = item.id === this.props.selectedId;
                return item;
            });
        } else {
            // console.log("PCB LAYER DUO COMMON");
            pcbThickness = thicknessLayer1.map((item) => {
                item.checked = item.id === this.props.selectedId;
                return item;
            });
        }

        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="col-md-3 text-right content-item-heading">
                            <FormattedMessage id="app.pcb-quotation.pcb-thickness"
                                              defaultMessage="PCB Thickness"
                                              description=""
                            />
                            &nbsp; &nbsp;
                            <Link id="pcbThick-qLink"
                                to={{pathname:"https://kitcutlabo.com/pcb-thickness/"}} target="_self"
                                className="glyphicon glyphicon-question-sign question-link"></Link>
                        </div>
                        <div className="btn-group col-md-9 pcb-details-div-items">

                            {this.props.pcbParam.layer === 4 ?
                                <RadioButtonGroup data={pcbThicknessLayer4} getParams={this.props.setPCBParams}/> : ""

                            }
                            {
                                this.props.pcbParam.layer === 6 ?

                                    <RadioButtonGroup data={pcbThicknessLayer6}
                                                      getParams={this.props.setPCBParams}/> : ""
                            }

                            {
                                this.props.pcbParam.layer === 1 ?

                                    <RadioButtonGroup data={pcbThickness} getParams={this.props.setPCBParams}/> : ""
                            }
                            {
                                this.props.pcbParam.layer === 2 ?

                                    <RadioButtonGroup data={pcbThicknessLayer2} getParams={this.props.setPCBParams}/> : ""
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PCBThickness;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PCBThickness.js